import { useCallback } from "react";

import type { Transaction } from "./get-transaction";
import type { Transactions } from "./get-transactions";
import { TransactionsListItemInput } from "./transactions-list/transactions-list-item";

export namespace TransactionsList {
	export type Props = {
		amount: number;
		amountAdjustable: boolean | undefined;
		error: string | boolean | undefined;
		disabled: boolean | undefined;
		transactions:
			| Transactions
			| Array<Transaction>
			| NonNullable<Transaction["refundTransactions"]>;
		message: string | undefined;
		onChange: (value: string | undefined) => void | undefined;
		name: string | undefined;
		value: string | undefined;
	} & (
		| {
				readOnly: true;
		  }
		| {
				readOnly: false | undefined;
				onChange: (value: string | undefined) => void;
				name: string;
				value: string | undefined;
		  }
	);

	export type Option = Props["transactions"][number];
}

export const TransactionsList = ({
	amount,
	amountAdjustable,
	name,
	error,
	disabled,
	readOnly,
	value,
	onChange,
	transactions,
	message,
}: TransactionsList.Props) => {
	const onSelectOption = useCallback(
		(id: string | undefined) => {
			onChange?.(id);
		},
		[onChange],
	);

	return (
		<fieldset className="h-auto w-full">
			{message && (
				<div className="pb-16 text-grey-550 dark:text-grey-400">{message}</div>
			)}
			<ul className="flex flex-col gap-8" role="listbox">
				{transactions?.map((transaction) => (
					<TransactionsListItemInput
						key={transaction.id}
						{...transaction}
						disabled={
							disabled || (!amountAdjustable && amount > transaction.amount)
						}
						name={name}
						onChange={onSelectOption}
						readOnly={readOnly}
						transaction={transaction}
						value={value}
					/>
				))}
				{error && <div className="text-red-500">{error}</div>}
			</ul>
		</fieldset>
	);
};
